export default __webpack_public_path__ + "static/media/leadsManagementIcon.7d23547c.svg";